<section class='item-list-table' [ngClass]='customClass'>
  <div [ngClass]="showNodata ? 'no-data-height' : ''">
    <!---Search Text box with sort and filter icon-->
    @if (showSearch) {
      <div class='search-bar' #searchBar >
        <app-table-search class="table-search" (clearsearchData)="clearData()" (filterSearch)="reservedFilter($event)" [innerfilterArray]="filterData"
          [searchdataInput]="searchData" [searchoptionalParams]="searchParms" (returnData)="receivedData($event)" (apiSearchOption)="apiSearchOption($event)" (clearSearch)="clearSearch()"
          [sortData]="sortData" [showSort]="showSort" [sortByOptions]="sortByOptions" [defaultSort]="defaultSort" (sortValue)='sortTable($event)'
          [filterId]="tableId" (openFilterCheckStatus)="clickFilter($event)" (openSortCheckStatus)="clickSort($event)"  (sortChangeEmit)="sortingOptionChanged($event)"
        [checkOnlineStatusforClick]="checkOnlineStatusforClick" (emitOffineforAutocompleteSearch)="emitOffineNodataforSearch()" [itemLength]='tableData?.length' [originalTableData]="originalData?.length" (sortedData)="sortedData($event)" [showFilterIcon]="showFilterIcon"></app-table-search> <!-- (callFocusOut)="autocompleteFO()" (callFocusIn)="autocompleteFI()" -->
      </div>
    }
    @if (showItemList) {
      <div class='item-list-title'>
        <span>{{'Requisition.itemList'| translate}}</span>
        <span class='item-count'>({{originalData?.length}})</span>
      </div>
    }
    @if (hideOfflineTitle ? (showRowTitle && ((tableData | filterPipe: searchText : searchKey).length > 0)): showRowTitle) {
      <div class='item-list-title' [ngClass]='rowTitleClass'>
        <span>{{showRowTitleData}}</span>
      </div>
    }
    <!-- Table Starts here-->
    <div id={{tableId}} [ngClass]="showNodata ? 'no-data-height' : ''">
      <!--Table header-->
      @if (showHeader) {
        <div class='table-header'>
          <!--Table header checkBox to select All-->
          @if (showCheckBox) {
            <div class='checkbox'>
              <!-- <mat-checkbox class='base-check-box' (change)="RowSelect($event,data,'All')" [(ngModel)]="IsCheckAll" [disabled]="disableCheckBox"></mat-checkbox> -->
              <app-checkbox [customCBxDisabled]="disableCheckBox" [customCBxChecked]="IsCheckAll" (changeEvent)="RowSelect($event,data,'All')" customCBxId="id_7"></app-checkbox>
            </div>
          }
          @for (header of tableHeader; track header) {
            <div class="header-col head-{{header.toLowerCase().split(' ').join('-')}}">{{header | translate}}</div>
          }
        </div>
      }

      <cdk-virtual-scroll-viewport #scroll [itemSize]="100" minBufferPx="1500" maxBufferPx="2000" class='table-body' id="app-tale-body-{{tableId}}"
        [ngClass]="{'no-data': showNodata,'showNoDataFullScreen':(showNoDataFullScreen && showNodata)}" (scroll)="onScroll($event)">

        <div *cdkVirtualFor="let data of tableData; let Index = index; trackBy: trackFunction">
          <div #apptablerow id="app-tale-row" class='table-row'>
            <!-- Table Body checkBox -->
            @if (showCheckBox && !disableCheckBox) {
              <div class='checkbox'>
                <app-checkbox
                  id="check{{Index}}"
                  [customCBxDisabled]="data.disableCheckBox !== undefined ? data.disableCheckBox : (data.showCancel !== undefined ? !data.showCancel : false)"
                  [customCBxChecked]="SelectedData.indexOf(data) !== -1"
                  customCBxId="id_7"
                  (changeEvent)="RowSelect($event, data, 'Single')">
                </app-checkbox>
              </div>
            }
            @if (showCheckBox && disableCheckBox) {
              <div class='checkbox'>
                <app-checkbox [customCBxDisabled]="data.disableCheckBox !== undefined ? data.disableCheckBox : disableCheckBox">
                </app-checkbox>
              </div>
            }

            <!-- Body data -->
            @for (header of tableColumn; track header; let i = $index) {
              <div class='body-col data-{{header}}' id='{{orderId[i]}}' [ngClass]="customRowClass[header]">
                @if (header !== 'checked' && header !== 'quantity' && header !== 'icon' && header !== 'isActive') {
                  <div class='body-data'>
                    <div class='body-header'>
                      <span class='icon-header' [ngClass]="headerIcon && headerIcon[i]"></span>
                      @if (header.includes('date') && !header.includes('dateTime')) {
                        <div>
                          {{tableHeader[i] | translate | dateformater}}
                        </div>
                      }
                      @if(header.includes('dateTime') && !header.includes('date')) {
                      <div>
                        {{tableHeader[i] | translate}}
                      </div>
                      }
                      @if (!header.includes('date') && !header.includes('dateTime')) {
                        <div>
                          {{tableHeader[i] | translate}}
                        </div>
                      }
                    </div>
                    <div class='body-content'
                      [ngClass]="showContentIcon && header === 'status' ? 'color-' + ((data.statusText ? data.statusText : '') | trimLower) : ''">
                      <span class="icon-before" [ngClass]="getIconClass(i, showContentIcon, header, data)">
                      </span>
                      <span class='name-icon'>{{data[header] | getIconName}}</span>
                      @if (header === 'qor') {
                        <span>
                          <span class='quantity'>{{data[header]}}</span>
                          <span class='unit'>{{data.unit}}</span>
                        </span>
                      }
                      @if (isHeaderVisible(header)) {
                        <span class='text'
                          [ngClass]="tableId === 'requsitionDetails' || tableId === 'transferDetails' || tableId === 'newPhysicalInventory' || tableId === 'poDetails' ? 'con-full-txt' : ((data.dropShip === 'yes' || data.dropShip === true) ? 'toWithDropShip' : '')"
                          [innerHTML]="data[header] | isEmpty | highlight: highlightText"
                          (click)="sync(data)">
                        </span>
                        @if (data?.isReversed && header === 'id') {
                          <i class="Reverse-transfer icon-reverse_updated"></i>
                        }
                        @if (data?.isConsignment && header === 'id') {
                          <i class="Consignment-item icon-Consignment"></i>
                        }
                      }
                      @if (header === showDropshipBeside && (data.dropShip === 'yes' || data.dropShip === true)) {
                        <span class="icon-dropship dropshipIcon"></span>
                      }
                      @if (header === showPriorityBeside) {
                        <span class="priority-icon icon-{{data[priorityKey]}}-priority"></span>
                      }
                    </div>
                  </div>
                }
                @if (showIcon && header === 'icon') {
                  <div class='name-icon'>
                    <span class='user d-inline-block'>{{data[header] | getIconName}}</span>
                    @if (tableId === 'suppliers') {
                      <i class="status {{data.status}}" aria-hidden="true"></i>
                    }
                  </div>
                }
                @if (header === 'isActive') {
                  <div class='body-data'>
                    <i [ngClass]="data[header] === 'true' ? 'icon-tick' : 'icon-not-active'"></i>
                  </div>
                }
              </div>
            }

            <!-- More options icon -->
            @if (data.disableCheckBox !== undefined && data.disablecopy !== undefined ? ((data.disablecopy || !data.disableCheckBox) && showMore ? true : false) : (data.showCancel !== undefined && moreOptions.length > 0 ? data.showCancel : showMore)) {
              <div class='body-col show-more'>
                @if (disableMore) {
                  <i class="icon-more disableMore"></i>
                }
                @if (!disableMore) {
                  <i class="icon-more" id="iconMore" [matMenuTriggerFor]="menu"></i>
                }
                <mat-menu #menu="matMenu">
                  @for (option of moreOptions; track option.id) {
                    @if((!(data?.ReversalTransfersId) && option.id === 'reverse') || option.id === 'copy' || option.id === 'cancel') {
                      @if (data.disableCheckBox !== undefined && data.disablecopy !== undefined ? (option.id === 'copy' ? data.disablecopy : !data.disableCheckBox) : (data.showCancel || (option.id !== 'cancel'))) {
                        <button mat-menu-item (click)="moreOptionsClicked(data, option.id)" id="{{option.id}}">
                          <i [class]='option.icon'></i>
                          <span class="text-capital">{{option.name | translate}}</span>
                        </button>
                      }
                    }
                  }
                </mat-menu>
              </div>
            }

            <!-- showSync -->
            @if (header === showSync && data.showSync) {
              <span class="icon-dropship dropshipIcon" (click)="sync(data)"></span>
            }

            <!-- Expand or Navigate to details icon -->
            @if (!data.authorized) {
              <div class='icon-back' id="iconback" (click)='rowClicked($event, data)'></div>
            }
          </div>
        </div>

        <!-- No Data Found message -->
        @if (noSearchData && searchText && (tableData | filterPipe: searchText : searchKey).length === 0) {
          <div class="table-row no-data-message">{{ 'common.noDataFound' | translate }}</div>
        }

        <!-- No Items Component -->
        @if (showNodata) {
          <app-no-items [addNewClass]="(showNoDataFullScreen && showNodata) ? 'noDataFullScreen' : ''"></app-no-items>
        }

      </cdk-virtual-scroll-viewport>

    </div>
  </div>
</section>